import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getElementData',
})
export class GetElementDataPipe implements PipeTransform {

  transform(soundData:any, element: string ): any {
    let finalList: Array<any> =[];
    if (soundData && element) {
      let elementLoop: any = soundData?.elementForLoopType;
      finalList = elementLoop[element]
    }
    return finalList;
  }

}
